module.exports = __webpack_public_path__ + "static/sv-2b59b54c818ef792a1fc27ee645dbf1a.svg";